import { useState, useContext, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import LogoWhite from '../../assets/scss/black-dashboard-react/panther/logo-white.svg';
import LogoWhiteNoAnim from '../../assets/scss/black-dashboard-react/panther/logo-white-none-anim.svg';
import LogoBlack from '../../assets/scss/black-dashboard-react/panther/logo.svg';
import LogoBlackNoAnim from '../../assets/scss/black-dashboard-react/panther/logoNoAnim.svg';

import TodosMisDepositos from './TodosMisDepositos';
import Direcciones from './Direcciones';
import DepositosPanama from './DepositosPanama';
import DepositosACH from './DepositosACH';

import AuthContext from '../../context/autenticacion/authContext';
import { useT } from 'i18n';

// Animaciones
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Styled Components
const DepositosCard = styled.div`
  background: ${props => props.theme === 'white' 
    ? '#fff' 
    : 'rgba(12,14,19, 0.6)'};
  backdrop-filter: blur(10px);
  border-radius: 24px;
  border: 1px solid ${props => props.theme === 'white' 
    ? 'rgba(0, 0, 0, 0.1)' 
    : 'rgba(227,168,43, 0.2)'};
  overflow: hidden;
  animation: ${fadeIn} 0.4s ease-out;
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem 2rem;
  background: ${props => props.theme === 'white' 
    ? 'linear-gradient(135deg, #f8f9fa, #e9ecef)' 
    : 'linear-gradient(135deg, rgba(18,21,28, 0.8), rgba(12,14,19, 0.9))'};
  border-bottom: 1px solid ${props => props.theme === 'white' 
    ? 'rgba(0, 0, 0, 0.05)' 
    : 'rgba(227,168,43, 0.2)'};

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 1.5rem;
  }
`;

const LogoBox = styled.div`
  flex-shrink: 0;
  
  img {
    height: 45px;
    width: auto;
  }
  
  .mobile-responsive-jimf { display: none; }
  
  @media (max-width: 768px) {
    .desktop-responsive-jimf { display: none; }
    .mobile-responsive-jimf { display: block; }
  }
`;

const HeaderInfo = styled.div`
  h2 {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 0.25rem;
    background: ${props => props.theme === 'white'
      ? 'rgba(227,168,43,.14)'
      : 'linear-gradient(135deg, #fff, #e3a82b)'};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  
  p {
    color: ${props => props.theme === 'white' ? '#666' : 'rgba(255, 255, 255, 0.7)'};
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
  
  span {
    font-size: 0.75rem;
    color: ${props => props.theme === 'white' ? '#999' : 'rgba(255, 255, 255, 0.5)'};
    strong { color: #e3a82b; }
  }
`;

const TabsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 1rem 2rem 0 2rem;
  background: ${props => props.theme === 'white' 
    ? '#f8f9fa' 
    : 'rgba(12,14,19, 0.4)'};
  border-bottom: 1px solid ${props => props.theme === 'white' 
    ? 'rgba(0, 0, 0, 0.05)' 
    : 'rgba(227,168,43, 0.15)'};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 1rem;
    justify-content: center;
  }
`;

const TabButton = styled.button`
  padding: 0.6rem 1.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  color: ${props => props.theme === 'white' ? '#666' : 'rgba(255, 255, 255, 0.7)'};
  
  ${props => props.active && `
    background: rgba(227,168,43,.14);
    color: #e3a82b;
    box-shadow: inset 0 0 0 1px rgba(227,168,43,.45);
  `}
  
  i { margin-right: 8px; }
  
  &:hover {
    transform: translateY(-2px);
    color: ${props => props.theme === 'white' ? '#e3a82b' : '#fff'};
    background: ${props => props.theme === 'white' 
      ? 'rgba(227,168,43, 0.1)' 
      : 'rgba(227,168,43, 0.15)'};
  }
`;

const ContentContainer = styled.div`
  padding: 1.5rem;
  min-height: 400px;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Depositos = () => {
  const { t } = useT();
  const authContext = useContext(AuthContext);
  const { jimf_theme, TodosDepositos } = authContext;

  useEffect(() => { if (TodosDepositos) TodosDepositos(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [layerout, setLayerOut] = useState({
    todos_mis_depositos: true,
    transferencia_nacional: false,
    transferencia_internacional: false,
    ach_panama: false,
  });

  const irAMisDepositos = () => {
    if (TodosDepositos) TodosDepositos();
    setLayerOut({ todos_mis_depositos: true, transferencia_nacional: false, transferencia_internacional: false, ach_panama: false });
    window.scrollTo(0, 0);
  };

  const TodosDepositosLay = () => {
    setLayerOut({
      todos_mis_depositos: true,
      transferencia_nacional: false,
      transferencia_internacional: false,
      ach_panama: false,
    });
  };

  const TransferenciaNacionalLay = () => {
    setLayerOut({
      todos_mis_depositos: false,
      transferencia_nacional: true,
      transferencia_internacional: false,
      ach_panama: false,
    });
  };

  const TransferenciaInterNacionalLay = () => {
    setLayerOut({
      todos_mis_depositos: false,
      transferencia_nacional: false,
      transferencia_internacional: true,
      ach_panama: false,
    });
  };

  const AchPanamaLay = () => {
    setLayerOut({
      todos_mis_depositos: false,
      transferencia_nacional: false,
      transferencia_internacional: false,
      ach_panama: true,
    });
  };

  const { todos_mis_depositos, transferencia_nacional, transferencia_internacional, ach_panama } = layerout;
  const isWhiteTheme = jimf_theme === 'white';

  return (
    <div className="content">
      <DepositosCard theme={isWhiteTheme ? 'white' : 'dark'}>
        
        {/* Header */}
        <HeaderSection theme={isWhiteTheme ? 'white' : 'dark'}>
          <LogoBox>
            {isWhiteTheme ? (
              <>
                <img src={LogoBlackNoAnim} className="mobile-responsive-jimf" alt="Panther7" />
                <img src={LogoBlack} className="desktop-responsive-jimf" alt="Panther7" />
              </>
            ) : (
              <>
                <img src={LogoWhiteNoAnim} className="mobile-responsive-jimf" alt="Panther7" />
                <img src={LogoWhite} className="desktop-responsive-jimf" alt="Panther7" />
              </>
            )}
          </LogoBox>
          <HeaderInfo theme={isWhiteTheme ? 'white' : 'dark'}>
            <h2>{t('dep.titulo')}</h2>
            <p>{t('dep.subtitulo')}</p>
            <span><strong>www.</strong>panther7<strong>.com</strong></span>
          </HeaderInfo>
        </HeaderSection>

        {/* Tabs */}
        <TabsContainer theme={isWhiteTheme ? 'white' : 'dark'}>
          <TabButton
            theme={isWhiteTheme ? 'white' : 'dark'}
            active={todos_mis_depositos}
            onClick={TodosDepositosLay}
          >
            <i className="tim-icons icon-coins" /> {t('dep.tabMis')}
          </TabButton>
          <TabButton
            theme={isWhiteTheme ? 'white' : 'dark'}
            active={transferencia_internacional}
            onClick={TransferenciaInterNacionalLay}
          >
            <i className="tim-icons icon-wallet-43" /> {t('dep.tabDonde')}
          </TabButton>
          <TabButton
            theme={isWhiteTheme ? 'white' : 'dark'}
            active={transferencia_nacional}
            onClick={TransferenciaNacionalLay}
          >
            <i className="tim-icons icon-cloud-upload-94" /> {t('dep.tabAvisar')}
          </TabButton>
          <TabButton
            theme={isWhiteTheme ? 'white' : 'dark'}
            active={ach_panama}
            onClick={AchPanamaLay}
          >
            <i className="tim-icons icon-bank" /> {t('dep.tabAch')}
          </TabButton>
        </TabsContainer>

        {/* Content */}
        <ContentContainer>
          {todos_mis_depositos && <TodosMisDepositos />}
          {transferencia_internacional && <Direcciones />}
          {transferencia_nacional && <DepositosPanama jimf_theme={jimf_theme} onCreado={irAMisDepositos} />}
          {ach_panama && <DepositosACH onCreado={irAMisDepositos} />}
        </ContentContainer>

      </DepositosCard>
    </div>
  );
};

export default Depositos;